import { addWarningNotification } from '@vista/omnichannel-components-domain';
export const handleItemQuantityChanged = (isMaxReached, isMaxAllowedReachedForDiscountedItem, displayText) => {
    if (isMaxAllowedReachedForDiscountedItem) {
        addWarningNotification({
            id: 'in-progress-item-reached-redemption-limit',
            messages: [displayText.inProgressItemRedemptionLimitReachedMessage]
        });
    }
    if (isMaxReached) {
        addWarningNotification({
            id: 'in-progress-item-reached-order-item-limit',
            messages: [displayText.inProgressItemLimitReachedMessage]
        });
    }
};
